import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=0e962efc&scoped=true&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSummary.vue?vue&type=style&index=0&id=0e962efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e962efc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e962efc')) {
      api.createRecord('0e962efc', component.options)
    } else {
      api.reload('0e962efc', component.options)
    }
    module.hot.accept("./CampaignSummary.vue?vue&type=template&id=0e962efc&scoped=true&", function () {
      api.rerender('0e962efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CampaignSummary.vue"
export default component.exports